module.exports = __webpack_public_path__ + "img/82.c99d1015.jpg";